import React, { useState } from 'react';
import { Star, X, Loader2, CheckCircle2 } from 'lucide-react';
import api from '../../api/axios'; // Verifica que esta ruta apunte a tu Axios

export default function ReviewModal({ isOpen, onClose, shipmentId, onReviewSuccess }) {
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [comment, setComment] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (rating === 0) {
            setError('Por favor, selecciona una calificación.');
            return;
        }
        
        setLoading(true);
        setError(null);

        try {
            await api.post('/reviews', {
                shipment_id: shipmentId,
                rating: rating,
                comment: comment
            });
            setSuccess(true);
            setTimeout(() => {
                onReviewSuccess(); 
                onClose();         
                setSuccess(false);
                setRating(0);
                setComment('');
            }, 2000);
        } catch (err) {
            setError(err.response?.data?.error || 'Ocurrió un error al enviar la reseña.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 lg:p-4">
            <div className="bg-white dark:bg-gradient-to-b dark:from-[#590000] dark:to-[#780000] w-full max-w-xl lg:max-w-md rounded-3xl p-10 lg:p-6 shadow-2xl relative border-[1.5px] border-black/10 dark:border-white/20 transition-all">
                
                <button onClick={onClose} className="absolute top-6 right-6 text-gray-500 dark:text-white/70 hover:scale-110 transition-transform">
                    <X className="w-8 h-8 lg:w-6 lg:h-6" />
                </button>

                {success ? (
                    <div className="text-center space-y-4 py-8 animate-fade-in">
                        <CheckCircle2 className="mx-auto text-green-500 dark:text-green-400 w-24 h-24 lg:w-16 lg:h-16" />
                        <h3 className="text-4xl lg:text-2xl font-black text-black dark:text-white uppercase">¡Gracias!</h3>
                        <p className="text-xl lg:text-base text-gray-600 dark:text-white/80">Tu opinión nos ayuda a mejorar.</p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="text-center space-y-2">
                            <h3 className="text-4xl lg:text-2xl font-black text-black dark:text-white uppercase" style={{ fontFamily: "'Secular One', sans-serif" }}>
                                Califica tu envío
                            </h3>
                            <p className="text-xl lg:text-sm text-gray-500 dark:text-white/70">¿Qué te pareció nuestro servicio?</p>
                        </div>

                        {/* Selector de Estrellas */}
                        <div className="flex justify-center gap-2">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <button
                                    key={star}
                                    type="button"
                                    onClick={() => setRating(star)}
                                    onMouseEnter={() => setHoverRating(star)}
                                    onMouseLeave={() => setHoverRating(0)}
                                    className="transition-transform hover:scale-110 focus:outline-none"
                                >
                                    <Star 
                                        className={`w-14 h-14 lg:w-9 lg:h-9 transition-colors ${
                                            star <= (hoverRating || rating) 
                                            ? 'text-yellow-400 fill-yellow-400 drop-shadow-[0_0_8px_rgba(250,204,21,0.5)]' 
                                            : 'text-gray-300 dark:text-white/20'
                                        }`} 
                                    />
                                </button>
                            ))}
                        </div>

                        {/* Comentario */}
                        <div className="space-y-2">
                            <textarea
                                rows="4"
                                placeholder="Escribe tu opinión aquí (opcional pero ayuda mucho)..."
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                className="w-full p-4 rounded-xl bg-gray-50 dark:bg-black/20 border border-gray-200 dark:border-white/10 text-black dark:text-white resize-none focus:ring-2 focus:ring-[#CE010B] outline-none text-xl lg:text-sm"
                            ></textarea>
                        </div>

                        {error && <p className="text-red-500 dark:text-red-300 text-lg lg:text-xs font-bold text-center">{error}</p>}

                        <button
                            type="submit"
                            disabled={loading || rating === 0}
                            className="w-full py-6 lg:py-4 rounded-2xl lg:rounded-xl font-black uppercase tracking-widest text-white bg-[#CE010B] dark:bg-[#CE010B] dark:text-white lg:dark:bg-white lg:dark:text-[#590000] disabled:opacity-50 transition-transform active:scale-95 flex justify-center items-center gap-2 text-xl lg:text-sm"
                        >
                            {loading ? <Loader2 className="animate-spin" size={20} /> : 'Publicar Reseña'}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}